import React from "react";
import NumberFormat from "react-number-format";

const NumberFormatTheme = React.forwardRef((props, ref) => {
  return <NumberFormat {...props} thousandSeparator getInputRef={ref}/>
})

export default NumberFormatTheme